import Skeleton from 'react-loading-skeleton';

export default function FeatureListingLoading() {
  return (
    <div className="feature-listing-grid">
      {Array(2)
        .fill(0)
        .map((_, index) => (
          <div
            className="feature-listing-card-item"
            key={`feature-loading-${index}`}
          >
            <div className="flex h-full w-full flex-col gap-2x rounded-[12px] border border-gray p-3x">
              <Skeleton height={24} width="40%" borderRadius={8} />
              <Skeleton height={48} borderRadius={8} />
              <Skeleton height={24} borderRadius={8} />
              <Skeleton height={40} borderRadius={26} />
            </div>
          </div>
        ))}
    </div>
  );
}
